import React, { useState, useEffect } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { Accordion, Card } from "react-bootstrap";
import DocumentView from "components/sales/downloadDocView/documentView";

const ViewFollowUp = ({ match, getFollowUpDetail, followUpDetails }) => {
  const [followUpData, setfollowUpData] = useState();
  const [followUpId, setfollowUpId] = useState();

  useEffect(() => {
    setfollowUpId(match.params.id);
  }, []);

  useEffect(() => {
    if (getFollowUpDetail !== null && followUpId)
      (async () => await getFollowUpDetail(followUpId))();
  }, [getFollowUpDetail, followUpId]);

  useEffect(() => {
    if (followUpDetails) {
      setfollowUpData(followUpDetails);
    }
  }, [followUpDetails]);

  return (
    <Layout title="Follow Up Details" isGoback>
      <div className="panel-card">
        <div className="panel-heading">{localization.followUpDetails}</div>
        <div className="panel-body">
          {followUpData && (
            <div className="details-listing">
              <div className="details-list">
                <strong className="data-title">
                  {localization.lastInteractionDate}
                </strong>
                <span className="data-details">
                  {followUpData.last_call_date}
                </span>
              </div>
              <div className="details-list">
                <strong className="data-title">
                  {localization.interactionType}
                </strong>
                <span className="data-details">
                  {followUpData.interaction_type &&
                    followUpData.interaction_type}
                </span>
              </div>
              <div className="details-list">
                <strong className="data-title">
                  {localization.currentStatus}
                </strong>
                <span className="data-details">{followUpData.deal_name}</span>
              </div>
              <div className="details-list">
                <strong className="data-title">
                  {localization.dropReason}
                </strong>
                <span className="data-details">{followUpData.drop_reason}</span>
              </div>
              <div className="details-list">
                <strong className="data-title">
                  {localization.nextActionDate}
                </strong>
                <span className="data-details">
                  {followUpData.next_action_date}
                </span>
              </div>
              <div className="details-list">
                <strong className="data-title">
                  {localization.expectedClosure}
                </strong>
                <span className="data-details">
                  {followUpData.expected_closure}
                </span>
              </div>
              <div className="details-list">
                <strong className="data-title">{localization.Notes}</strong>
                <span className="data-details">{followUpData.remarks}</span>
              </div>
              {followUpData.document && <DocumentView title={localization.quotation} attachment={followUpData.document && followUpData.document} />}
            </div>
          )}
        </div>
        <div className="panel-card">
          <div className="panel-heading">POC Details</div>
          <div className="panel-body">
            <Accordion defaultActiveKey="0" className="w-100">
              {followUpData &&
                followUpData.poc &&
                followUpData.poc.map((obj, index) => {
                  return (
                    <Card key={index + 1}>
                      <Card.Header>
                        <Accordion.Toggle
                          as={Card.Header}
                          variant="link"
                          eventKey={index + 1}
                        >
                          {obj.name}
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey={index + 1}>
                        <Card.Body>
                          <div className="details-listing">
                            <div className="details-list">
                              <strong className="data-title">
                                {localization.name}
                              </strong>
                              <span className="data-details">{obj.name}</span>
                            </div>
                            <div className="details-list">
                              <strong className="data-title">
                                {localization.designation}
                              </strong>
                              <span className="data-details">
                                {obj.designation}
                              </span>
                            </div>
                            <div className="details-list">
                              <strong className="data-title">
                                {localization.mobileNumber}
                              </strong>
                              <span className="data-details">
                                {obj.contact_no}
                              </span>
                            </div>
                            <div className="details-list">
                              <strong className="data-title">
                                {localization.emailAddress}
                              </strong>
                              <span className="data-details">{obj.email}</span>
                            </div>
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  );
                })}
            </Accordion>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ViewFollowUp;
